export default "__VITE_ASSET__CB3NjOs0__"